import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { UpdateSlackConfiguration } from '@cast/types';

import { getSlackConfigurationsQueryKey } from 'hooks/queries/notifications/useGetSlackConfigurations';

export const useUpdateSlackConfiguration = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      config,
    }: {
      id: string;
      config: UpdateSlackConfiguration;
    }) => {
      return apiClient.notifications.updateSlackConfiguration({ id, config });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getSlackConfigurationsQueryKey(),
      });
      notify.success('Slack configuration updated successfully');
      onSuccess?.();
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
